import React, { useState } from "react";

export default function MultiSelect({ label, options, value = [], onChange, testPrefix = "ms", allowOther = true, maxItems = 20 }) {
  const [other, setOther] = useState("");
  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else if (value.length < maxItems) onChange([...value, opt]);
  };
  const addOther = () => {
    const v = other.trim();
    if (!v) return;
    if (!value.includes(v) && value.length < maxItems) onChange([...value, v]);
    setOther("");
  };
  return (
    <div>
      <div className="text-[11px] uppercase tracking-widest text-purple-200/70 mb-1.5">{label}</div>
      <div className="flex flex-wrap gap-1.5">
        {options.map((o) => {
          const active = value.includes(o);
          return (
            <button
              type="button"
              key={o}
              data-testid={`${testPrefix}-${o.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => toggle(o)}
              className={`px-3 py-1 rounded-full text-xs border transition ${active ? "bg-fuchsia-500 text-white border-fuchsia-400" : "bg-purple-900/40 text-purple-200 border-purple-500/30 hover:bg-purple-900/70"}`}
            >
              {o}
            </button>
          );
        })}
        {value.filter((v) => !options.includes(v)).map((o) => (
          <button
            type="button"
            key={o}
            onClick={() => onChange(value.filter((v) => v !== o))}
            className="px-3 py-1 rounded-full text-xs bg-fuchsia-500 text-white border border-fuchsia-400"
          >
            {o} ×
          </button>
        ))}
      </div>
      {allowOther && (
        <div className="mt-2 flex gap-2">
          <input
            value={other}
            onChange={(e) => setOther(e.target.value)}
            placeholder="Add other…"
            className="flex-1 bg-black/40 border border-purple-500/30 rounded-xl px-3 py-1.5 text-xs text-white outline-none"
            data-testid={`${testPrefix}-other-input`}
          />
          <button type="button" onClick={addOther} className="px-3 rounded-xl bg-purple-700 text-white text-xs">Add</button>
        </div>
      )}
    </div>
  );
}
